import {
  Component,
  AfterViewChecked,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { ResipesService } from '../shared/services/resipes-service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentUrl } from '../shared/services/environment-url';
import { TableModule } from '@openng/optimus-ui/table';
import { CardModule } from '@openng/optimus-ui/card';
import { CategoriesModel } from '../_interfaces/Categories';
import { RecipeModel } from '../_interfaces/recipe';

@Component({
  selector: 'app-list-resipes',
  imports: [TableModule, CardModule, RouterLink],
  templateUrl: './recipelist.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './recipelist.css',
})
export class Resipelist implements AfterViewChecked {
  resibesService?: ResipesService;
  data: RecipeModel[] = [];
  categories: CategoriesModel[] = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private http: HttpClient,
    private envUrl: EnvironmentUrl,
  ) {
    this.resibesService = new ResipesService(this.http, this.envUrl);
  }

  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }

  ngAfterViewInit() {
    this.resibesService?.list().subscribe((at) => {
      this.data = at as RecipeModel[];
      this.data.forEach((item) => {
        if (item.category != null && !this.categories.some((x) => x.id == item.category?.id))
          this.categories.push(item.category);
      });
      this.changeDetectorRef.detectChanges();
    });
  }
}
